import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@material-ui/core';
import { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';

import { Button } from '../../../../../shared/components/Button';
import { Input } from '../../../../../shared/components/Form/Input';
import { PageContainer } from '../../../../../shared/components/PageContainer';
import { useSnackMessages } from '../../../../../shared/hooks/useSnackMessages';
import { api } from '../../../../../shared/services/apiClient';
import { ICustomData, IForm } from '../types';
import { schema } from './schema';

export function NotificationEdit() {
  const history = useHistory();
  const { state } = useLocation<{ notification: ICustomData }>();
  const { msgSuccess, msgError } = useSnackMessages();

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues: {
      ...state?.notification,
    },
  });

  const handlePush = useCallback(() => {
    history.push('/notifications');
  }, [history]);

  useEffect(() => {
    if (!state?.notification?.id) {
      handlePush();
    }
  }, [state?.notification?.id, handlePush]);

  const onSubmit = useCallback(
    ({ message }: IForm) => {
      const formatData = {
        message,
      };

      api
        .put(`/message/${state?.notification.id}`, formatData)
        .then(() => {
          msgSuccess('Mensagem atualizada com sucesso!');
          handlePush();
        })
        .catch((err) => {
          msgError(err.response?.data?.message);
        });
    },
    [state?.notification?.id, handlePush, msgSuccess, msgError]
  );

  return (
    <PageContainer component="form" onSubmit={handleSubmit(onSubmit)}>
      <Box
        display="grid"
        gridTemplateColumns="repeat(auto-fit, minmax(200px, 1fr))"
        gridGap={24}
        mb={3}
      >
        <Input
          name="message"
          multiline
          minRows={4}
          control={control}
          error={errors}
          label="Mensagem"
          variant="outlined"
          fullWidth
          disabled={isSubmitting}
          required
          inputProps={{ maxLength: 500 }}
          placeholder="500 caracteres"
        />
      </Box>

      <Box display="flex" justifyContent="flex-end">
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isSubmitting}
          size="large"
        >
          Salvar
        </Button>
      </Box>
    </PageContainer>
  );
}
